module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_29.c5fb80b0.pdf";